import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { getFilteredTourSteps } from './tourData';

const NavigationTour = ({ autoStart = false, onComplete }) => {
  const { startTour } = useShepherdTour('navigation', getFilteredTourSteps('navigation'), autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Navigation Tour
    </button> */}
    </>
  );
};

export default NavigationTour;
